const {
  MODE,
  VITE_API_URL,
  VITE_APP_VERSION,
  VITE_ENABLE_MOCK,
  VITE_MERCURE_HUB_URL,
  VITE_RECAPTCHA_SITE_KEY,
} = import.meta.env;

interface Config {
  appVersion: string;
  csrfTokenCookieName: string;
  navigationType: "hash" | "history";
  useSampleData?: boolean;
  api: {
    useMocks?: boolean;
    url: string;
  };
  auth: {
    signIn: string;
    signOut: string;
    validateToken: string;
    omniauthAzureUrl: string;
  };
  mercure: {
    hubUrl: string;
  };
  recaptchaSiteKey: string;
}

export const config: Config = {
  api: {
    url: VITE_API_URL || "http://localhost:3000",
    useMocks: VITE_ENABLE_MOCK
      ? VITE_ENABLE_MOCK === "true"
      : MODE === "development",
  },
  appVersion: VITE_APP_VERSION || "development",
  auth: {
    omniauthAzureUrl: "/api/v1/auth/entra_id",
    signIn: "/api/v1/auth/sign_in",
    signOut: "/api/v1/auth/sign_out",
    validateToken: "/api/v1/auth/validate_token",
  },
  csrfTokenCookieName: "SELLTO-CSRF-TOKEN",
  mercure: {
    hubUrl: VITE_MERCURE_HUB_URL || "",
  },
  navigationType: "history",
  recaptchaSiteKey: VITE_RECAPTCHA_SITE_KEY || "",
  useSampleData: false,
};
